import Vue from 'vue'
import { fetchBrands, createBrand, updateBrand, deleteBrand } from '@/api'
import router from '@/router';

/**
 * @var {{ brands }} lang
 */
export default {
    namespaced: true,
    state: {
        paginated: {
            current: 1,
            data: [],
            total: 1,
            pageSize: 10,
            showQuickJumper: true
        },
        visible: false,
        isLoading: false
    },
    mutations: {
        SET_PAGINATED_BRANDS: (state, paginated) => state.paginated = paginated,
        TOGGLE_VISIBLE: state => state.visible = !state.visible,
        SET_LOADING: state => state.isLoading = !state.isLoading,
        FORCE_CLOSE_MODAL: state => state.visible = false
    },
    actions: {
        /**
         *
         * @param {function} commit
         * @param {object} state
         * @param {int} page
         * @param {boolean} force
         */
        fetchBrands ({ commit, state }, { page = 1, force = false }) {
            if (force || !state.paginated.data.length) {
                commit('SET_LOADING');

                fetchBrands(page)
                    .then(res => {

                    commit('SET_PAGINATED_BRANDS', {
                        ...res.data,
                        current: res.data.current_page,
                        pageSize: res.data.per_page,
                        data: res.data.data
                    });

                    commit('FORCE_CLOSE_MODAL');

                    // if (router.history.current.query.page && router.history.current.query.page !== page) {
                        router.replace({ query: { page } });
                    // }

                }).finally(() => commit('SET_LOADING'))
            }
        },

        /**
         *
         * @param {function} dispatch
         * @param {function} commit
         * @param {{ name: string, type: int, index: int, active: boolean }} brand
         */
        create ({ dispatch, commit }, brand) {
            createBrand(brand)
                .then(() => {

                    dispatch('fetchBrands', { force: true });
                    commit('TOGGLE_VISIBLE');

                    Vue.prototype.$message.success('Marca creada con éxito').finally(() => false)
            })
        },

        /**
         *
         * @param {function} dispatch
         * @param {{ name?: string, type?: int, index?: int, active?: boolean }} brand
         */
        update ({ dispatch }, brand) {
            updateBrand(brand)
                .then(() => dispatch('fetchBrands', { force: true }))
        },

        /**
         *
         * @param {function} dispatch
         * @param {int} id
         */
        remove ({ dispatch }, id) {
            deleteBrand(id)
                .then(() => dispatch('fetchBrands', { force: true }))
        }
    },
    getters: {
        fields: (state, getters, rootState, rootGetters) => {
            const lang = rootGetters.lang.brands.main_table;

            return [
                { title: '', dataIndex: 'id', key: 'id', scopedSlots: { customRender: 'see_brand' } },
                { title: lang.name, dataIndex: 'name', scopedSlots: { customRender: 'name' } },
                { title: lang.display_name, dataIndex: 'display_name', scopedSlots: { customRender: 'display_name' } },
                { title: lang.field, dataIndex: 'field', scopedSlots: { customRender: 'field' } },
                { title: lang.index, dataIndex: 'index', scopedSlots: { customRender: 'index' } },
                { title: lang.image_folders_list, dataIndex: 'image_folders', scopedSlots: { customRender: 'image_folders' } },
                { title: lang.status, dataIndex: 'status', scopedSlots: { customRender: 'status' } },
                { title: lang.created_at, dataIndex: 'created_at', scopedSlots: { customRender: 'created_at' } },
                { title: '', dataIndex: 'id', key: 'delete', scopedSlots: { customRender: 'delete' } },
            ]
        }
    }
}
